import React from 'react';
import { useAuth } from './AuthContext';
import LoginPage from './LoginPage';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth(); // Changed from isAuthenticated

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-800 dark:bg-black flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin-glow rounded-full h-12 w-12 border-4 border-teal-300 border-t-transparent mx-auto mb-4"></div>
          <p className="text-teal-300">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  if (!user) { // Changed from !isAuthenticated
    return <LoginPage />;
  }

  return children;
};

export default ProtectedRoute;